import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import App from './App';
import reduxStore from './store';
import reportWebVitals from './reportWebVitals';
import './styles/index.css';
import 'react-credit-cards/es/styles-compiled.css';
// import 'leaflet/dist/leaflet.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={createStore(reduxStore)}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
